import XQuickDataView from './XQuickDataView'

export default XQuickDataView
